var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b2b-list-item',{on:{"click":_vm.$_onClick}},[_c('b2b-list-item-title',{domProps:{"textContent":_vm._s(_vm.$t('install-app'))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }